module.exports = __webpack_public_path__ + "employee_teal.d2c019a0dedb7cf20242.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/employee_teal.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/employee_teal.svg
// module chunks = styles